import LiveOrders from "../../pages/LiveOrders";
import OrderHistory from "../../pages/OrderHistory";
import WaiterSingup from "../../pages/WaiterSingup";
import { Route } from "react-router-dom";
export const Waiterroutes = () => {
  return (
    <>
      <Route exact path="/waiter-signup" component={WaiterSingup} />
      <Route exact path="/order-history" component={OrderHistory} />
      <Route exact path="/liveorders" component={LiveOrders} />
    </>
  );
};
